@if (splashBanner) {
	<section class="splash-banner">
		<app-adaptive-image
			class="splash-banner__image"
			[image]="splashBanner.image"
		></app-adaptive-image>

		<div class="splash-banner__content">
			<div>
				@if (splashBanner.name) {
					<h3 class="splash-banner__name">
						{{ splashBanner.name }}
					</h3>
				}
				@if (splashBanner.descriptionFormatted) {
					<p
						class="splash-banner__description"
						[innerHTML]="splashBanner.descriptionFormatted"
					></p>
				}
			</div>

			@if (routeAction$ | async; as routeAction) {
				@if (splashBanner.buttonName) {
					<app-route-action-link
						[action]="routeAction"
						class="button splash-banner__button"
					>
						{{ splashBanner.buttonName }}
					</app-route-action-link>
				}
			}
		</div>
	</section>
}
